module.exports = __webpack_public_path__ + "img/ear-left.57c46c91.png";